
import Vue from 'vue';
import { TranslateResult } from 'vue-i18n';
import { Icon, Avatar, Button, IconButton } from '@descomplica/vue-components';
import { ListItemModel, ListModel, UserModel } from '@descomplica/dex-models';
import LessonMenuItem from './LessonMenuItem.vue';
import i18n from '../i18n';
import { NoteModel } from '@/models/student-notes/note.model';
import { badgeCounter } from '@/helpers/number';
import Analytics from '@/helpers/analytics';
import { EVENT_LABELS } from '@/helpers/analytics/labels';
import { showEqualWebDrawer } from '../helpers/equalWeb';

interface Data {
  accessibilityClasses: string;
  isMenuExpanded: boolean;
}

export default Vue.extend({
  components: {
    Icon,
    LessonMenuItem,
    Avatar,
    Button,
    IconButton,
  },
  props: {
    list: {
      type: Object as Vue.PropType<ListModel>,
      required: true,
    },
    currentClassroomName: {
      type: String,
      default: '',
    },
    formatedItems: {
      type: Array as Vue.PropType<ListItemModel[]>,
      required: true,
    },
    currentItem: {
      type: Object as Vue.PropType<ListItemModel>,
      default: () => {},
    },
    onClick: {
      type: Function,
      default: null,
    },
    teacher: {
      type: Object as Vue.PropType<UserModel | null>,
      default: null,
    },
    isBulletListDisplayed: {
      type: Boolean,
      default: false,
    },
    videoNotes: {
      type: Array as Vue.PropType<NoteModel[]>,
      required: true,
      default: () => [],
    },
  },
  data(): Data {
    return {
      accessibilityClasses: 'accessibility-icon',
      isMenuExpanded: false,
    };
  },
  computed: {
    shouldShowAccessibilityIcon(): boolean {
      return this.$store.getters.shouldShowEqualWebWidget;
    },
    close(): TranslateResult {
      return i18n.t('closeButton');
    },
    annotations(): TranslateResult {
      return i18n.t('ownAnnotations');
    },
    shouldShowBadgeCount(): boolean {
      return this.videoNotes.length > 0;
    },
    badgeCount(): string {
      return badgeCounter(this.videoNotes.length, 9);
    },
    isPostgraduateCourse(): boolean {
      return this.$store.getters.isPostgraduateCourse;
    },
  },
  methods: {
    trackAccessibilityIconClick(): void {
      Analytics.trackEvent(EVENT_LABELS.acessibilityButtonClick, {
        is_drawer_open_button: true,
        is_inside_class: true,
      });
    },
    showEqualWebDrawerAndTrack(): void {
      this.trackAccessibilityIconClick();

      showEqualWebDrawer();
    },
    toggleHoverClassesForAccessibility(): void {
      if (this.isMenuExpanded) {
        this.accessibilityClasses = 'accessibility-icon';
      }

      if (!this.isMenuExpanded) {
        this.accessibilityClasses = 'accessibility-icon on-menu-hover';
      }

      this.isMenuExpanded = !this.isMenuExpanded;
    },
    toggleBulletList(): void {
      if (this.isBulletListDisplayed) {
        this.$emit('toggleBulletList');
      }
    },
    toggleNotes(): void {
      this.$emit('toggleNotes');
    },
  },
});
